import { render, staticRenderFns } from "./TaxRates.vue?vue&type=template&id=d19c4c1a&scoped=true&"
import script from "./TaxRates.vue?vue&type=script&lang=js&"
export * from "./TaxRates.vue?vue&type=script&lang=js&"
import style0 from "./TaxRates.vue?vue&type=style&index=0&id=d19c4c1a&lang=scss&scoped=true&"
import style1 from "./TaxRates.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19c4c1a",
  null
  
)

export default component.exports